export const INTEGRATIONS_SET_INTEGRATIONS = 'INTEGRATIONS_SET_INTEGRATIONS'
export const INTEGRATIONS_SET_SYSTEMS = 'INTEGRATIONS_SET_SYSTEMS'
export const INTEGRATIONS_SET_INTEGRATION_FILTERS = 'INTEGRATIONS_SET_INTEGRATION_FILTERS'
